"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyPointTask = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var point_1 = require("../../model/point");
var service_1 = require("../../../library/base/service");
var MyPointTask = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(MyPointTask, _super);
    function MyPointTask() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '我的积分任务';
        _this.code = '101031';
        _this.desc = '我的积分任务';
        _this.requestParams = new point_1.MyPointTaskRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return MyPointTask;
}(service_1.BaseService));
exports.MyPointTask = MyPointTask;
//# sourceMappingURL=myPointTask.js.map